export default function serviceWorkerRegistration() {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/ServiceWorker.js')
            .then((registration) => {
                console.log('Service Worker registered with scope:')
            })
        .catch((error) => {
            console.error('Service Worker registration failed:', error)
        })
    })
    }
}